import {useQuery} from 'react-query';
import {fetchProductivityScoreSeries} from '../api/reportsApi';

export function useProductivityScoreSeries(token, timeRange) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    const isSupportedRange = timeRange === 'WEEKLY' || timeRange === 'MONTHLY';

    return useQuery({
        queryKey: ['productivity-score-series', timeRange, timezone, token],
        queryFn: () => fetchProductivityScoreSeries(token, timeRange, timezone),
        enabled: !!token && isSupportedRange,
    });
}
